import { Verdict } from '@exam-management/graphql';
import { FormRadioSelection, CloseIcon, CheckIcon, Flex, Text } from '@shared/components';

export default function QuestionReviewResultForm() {
  return (
    <FormRadioSelection
      name='result'
      options={[
        {
          label: (
            <Flex sx={{ gap: (theme) => theme.spacing(2) }}>
              <CheckIcon />
              <Text variant='body2'>เห็นด้วย</Text>
            </Flex>
          ),
          value: Verdict.Approved,
        },
        {
          label: (
            <Flex sx={{ gap: (theme) => theme.spacing(2) }}>
              <CloseIcon />
              <Text variant='body2'>ไม่เห็นด้วย</Text>
            </Flex>
          ),
          value: Verdict.Rejected,
        },
      ]}
      radioProps={{
        sx: (theme) => ({
          '& .MuiRadio-root': {
            p: 0,
            color: theme.palette.grey[400],
            '&.Mui-checked .MuiSvgIcon-root': {
              color: (theme) => theme.palette.primary.main,
            },
          },
        }),
      }}
      sx={(theme) => ({
        '& .MuiFormControlLabel-root': {
          width: '200px',
          border: `1px solid ${theme.palette.grey[300]}`,
          borderRadius: theme.shape.rounded(1.5),
          p: theme.spacing(3, 4),
          ml: 0,
          flexDirection: 'row-reverse',
          justifyContent: 'space-between',
        },
        '& .MuiFormControlLabel-root:has(.MuiRadio-root.Mui-checked)': {
          borderColor: theme.palette.primary.main,
        },
      })}
      row
      required
    />
  );
}
